import type { AvailableReportKey } from '@parkchirp/reporting';
import type { ComponentType } from 'react';
import { BankReconciliationReportForm } from './BankReconciliationReportForm';
import { CashBasisPaymentReportForm } from './CashBasisPaymentReportForm';
import { DailyRevenueForm } from './DailyRevenueForm';
import { FacilitySettingsReportingForm } from './FacilitySettingsReportingForm';
import { InvoiceDetailReportForm } from './InvoiceDetailReportForm';
import { InvoiceMonthlyDetailReportForm } from './InvoiceMonthlyDetailReportForm';
import { InvoiceAdjustmentsReportForm } from './invoiceAdjustmentReportForm';
import { LeaseAllocationReportForm } from './LeaseAllocationReportForm';
import { ManagementSummaryReportForm } from './ManagementSummaryReportForm';
import { MissingDailyRevenueReportForm } from './MissingDailyRevenueReportForm';
import { MonthlyParkingPaymentForm } from './MonthlyParkingPaymentForm';
import { OutstandingBalanceReportForm, OutstandingBalanceSummaryReportForm } from './OutstandingBalanceSummaryReport';
import { PaymentReconciliationReportForm } from './PaymentReconciliationReportForm';
import { PaymentSummaryReportForm } from './PaymentSummaryReportForm';
import { PreviewAutoInvoiceModernReportForm } from './PreviewAutoInvoiceModernReportForm';
import { SalesDetailReportForm } from './SalesDetailReportForm';
import { SalesPaymentDetailReportForm } from './SalesPaymentDetailReportForm';
import { SalesReportValDetailReportForm } from './SalesReportValDetailReportForm';
import { SignUpTerminationReportForm } from './SignUpTerminationReportForm';
import { SubscriptionActivityReportForm } from './SubscriptionActivityReportForm';
import { TaxReportForm } from './TaxReportForm';
import { TicketReconciliationForm } from './TicketReconciliationForm';
import { TransactionReportForm } from './TransactionReportForm';
import type { ReportFormProps } from './types';
import { ValidationAndOtherDetailReportForm } from './ValidationAndOtherDetailReportForm';

export const reportComponents = {
	paymentSummary: PaymentSummaryReportForm,
	cashBasisPayment: CashBasisPaymentReportForm,
	tax: TaxReportForm,
	transaction: TransactionReportForm,
	invoiceAdjustment: InvoiceAdjustmentsReportForm,
	invoiceMonthlyDetail: InvoiceMonthlyDetailReportForm,
	invoice: InvoiceDetailReportForm,
	monthlyParkingPayment: MonthlyParkingPaymentForm,
	validationAndOtherDetail: ValidationAndOtherDetailReportForm,
	signUpTermination: SignUpTerminationReportForm,
	paymentReconciliation: PaymentReconciliationReportForm,
	outstandingBalance: OutstandingBalanceReportForm,
	outstandingBalanceSummary: OutstandingBalanceSummaryReportForm,
	bankReconciliation: BankReconciliationReportForm,
	previewAutoInvoice: PreviewAutoInvoiceModernReportForm,
	dailyRevenue: DailyRevenueForm,
	salesDetail: SalesDetailReportForm,
	ticketReconciliation: TicketReconciliationForm,
	salesReportValDetail: SalesReportValDetailReportForm,
	salesPaymentDetail: SalesPaymentDetailReportForm,
	leaseManagerAllocation: LeaseAllocationReportForm,
	managementSummary: ManagementSummaryReportForm,
	subscriptionActivity: SubscriptionActivityReportForm,
	subscriptionActivitySummary: SubscriptionActivityReportForm,
	missingDailyRevenue: MissingDailyRevenueReportForm,
	facilitySettings: FacilitySettingsReportingForm,
} satisfies Record<AvailableReportKey, ComponentType<ReportFormProps>>;
